import {Component, inject, OnInit} from '@angular/core';
import {RouterOutlet} from '@angular/router';
import {Navbar} from './navbar/navbar';
import {MarkdownModule} from 'ngx-markdown';
import {AuthService} from './services/auth';
import {TranslateService} from '@ngx-translate/core';
import {Sidebar} from './sidebar/sidebar';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    Navbar,
    Sidebar
  ],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App {
  protected title = 'frontend';
  // private translate: TranslateService = inject(TranslateService)
  constructor(private translate: TranslateService) {
    // Add available languages
    translate.addLangs(['en', 'nl', 'es', 'da', 'de', 'fr', 'sv', 'it', 'pt']);  // add your supported languages

    // Set default language if detection fails
    translate.setDefaultLang('en');

    // Detect browser language
    const browserLang = translate.getBrowserLang();
    console.log(browserLang)

    // Use detected language if supported, else fallback to default
    translate.use(browserLang && ['en', 'nl', 'es', 'da', 'de', 'fr', 'sv', 'it', 'pt'].includes(browserLang) ? browserLang : 'en');
  }
}
